<app-attributes-step [productId]="2000300000000000" productType="edit" />
